<p-table
  dataKey="serviceLineId"
  data-test-id="single-service-line-table"
  selectionMode="single"
  [alwaysShowPaginator]="false"
  [metaKeySelection]="false"
  [paginator]="true"
  [rows]="5"
  [scrollable]="true"
  [value]="services"
  [(selection)]="selected"
  (onRowSelect)="onRowSelect($event)"
  (onRowUnselect)="onRowUnselect()">
  <ng-template let-columns pTemplate="header">
    <tr>
      <!-- TODO take out styles in .ts -->
      <th style="width: 100px">Service No</th>
      <th style="width: 300px">Date Time Created</th>
      <th style="width: 300px">Date Time Request Received</th>
      <th style="width: 140px">Urgency</th>
      <th style="width: 140px">Requested Days</th>
      <th style="width: 140px">Approved Days</th>
      <th style="width: 140px">Effective From</th>
      <th style="width: 180px">Effective Through</th>
      <th style="width: 140px">Status</th>
      <!-- The Decision column name was changed to Processed under CR-237303. The difference between column name and DTO property name IS intentional -->
      <th style="width: 180px">Processed Date</th>
      <th style="width: 140px">Date Urgency Change Downgr.</th>
      <th style="width: 140px">Date Extension Taken</th>
      <th style="width: 250px">Status Reason</th>
    </tr>
  </ng-template>
  <ng-template let-rowData pTemplate="body">
    <tr [class.p-highlight]="rowData === selected" [pSelectableRow]="rowData">
      <td>{{ rowData['serviceNumber'] }}</td>
      <td>{{ rowData['createdDate'] | utcToLocal: 'MM/dd/yyyy hh:mm:ss a'}}</td>
      <td>{{ rowData['requestReceivedDate'] | utcToLocal: 'MM/dd/yyyy hh:mm:ss a'}}</td>
      <td>{{ rowData.urgency }}</td>
      <td>{{ rowData['daysRequested'] }}</td>
      <td>{{ rowData['daysApproved'] }}</td>
      <td>{{ rowData['effectiveStartDate'] | utcDateWithoutTimeZone: 'MM/dd/yyyy'}}</td>
      <td>{{ rowData['effectiveEndDate'] | utcDateWithoutTimeZone: 'MM/dd/yyyy'}}</td>
      <td>{{ rowData.serviceStatus }}</td>
      <!-- Processed Date -->
      <!-- The Decision column name was changed to Processed under CR-237303. The difference between column name and DTO property name IS intentional -->
      <td>{{ rowData['decisionDate'] | utcToLocal: 'MM/dd/yyyy hh:mm:ss a'}}</td>
      <td>{{ rowData['urgencyChangeDate'] | utcToLocal: 'MM/dd/yyyy hh:mm:ss a'}}</td>
      <td>{{ rowData['extensionTakenDate'] | utcToLocal: 'MM/dd/yyyy hh:mm:ss a'}}</td>
      <td>
        <span
          class="truncate"
          tooltipPosition="bottom"
          tooltipStyleClass="tooltip-xl-size"
          [pTooltip]="rowData.serviceStatusReason"
        >
          {{ rowData.serviceStatusReason }}
        </span>
      </td>
    </tr>
  </ng-template>
</p-table>
